<div class="modal-header">
    <div>
        <h4 class="modal-title">Staff's Reviews</h4>
        <small class="text-muted">
            {{ reviews.length }} reviews
        </small>
    </div>

    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()">
    </button>
</div>

<div class="modal-body">
    <div *ngIf="reviews.length > 0; else noReviews">
        <div class="rating-summary">
            <h6 class="mb-3">Rating Breakdown</h6>

            <div class="rating-row" *ngFor="let star of [5, 4, 3, 2, 1]">

                <span class="star-label">{{ star }} ★</span>

                <div class="rating-progress">
                    <div class="rating-progress-fill" [style.width.%]="getRatingPercentage(star)">
                    </div>
                </div>

                <span class="rating-count">
                    {{ getRatingCount(star) }}
                </span>
            </div>
        </div>
        <div *ngFor="let review of reviews" class="review-item">

            <div class="d-flex align-items-start gap-3">
                <img *ngIf="review.avatar" [src]="review.avatar" class="review-avatar" [alt]="review.name" />

                <div class="flex-grow-1">
                    <div class="d-flex justify-content-between
                   align-items-start flex-wrap">

                        <h6 class="mb-1">{{ review.name }}</h6>

                        <small class="text-muted">
                            {{ review.date | date:'mediumDate' }}
                        </small>
                    </div>

                    <div class="stars mb-2">
                        <ng-container *ngFor="let star of getStars(review.rating)">

                            <span [class.filled]="star <= review.rating">
                                ★
                            </span>

                        </ng-container>

                        <span class="rating-number">
                            {{ review.rating }}/5
                        </span>
                    </div>

                    <p class="review-comment mb-0">
                        {{ review.comment }}
                    </p>
                </div>
            </div>
        </div>

    </div>

    <ng-template #noReviews>
        <div class="text-center py-5">
            <h6>No reviews yet</h6>
            <p class="text-muted mb-0">
                Comments and ratings will appear here.
            </p>
        </div>
    </ng-template>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="activeModal.close()">
        Close
    </button>
</div>